import { Component, HostListener, ViewEncapsulation } from '@angular/core';

@Component({
  selector: `button[ca-raised-button], button[caRaisedButton]`,
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./raised-button.scss'],
  host: {
    class: 'mat-flat-button round',
  },
})
export class CaRaisedButtonComponent {
  @HostListener('disabled') disabled;
}
